import React from "react";
import { fmtCurrency } from "@/lib/format";

export default function DividendCalendar({ events }) {
  const upcoming = (events || []).filter((e) => e.pay_date);

  return (
    <div className="card" data-testid="dividend-calendar">
      <p className="label-xs mb-1">Schedule</p>
      <h3 className="font-serif text-2xl mb-6">Dividend calendar</h3>

      {upcoming.length === 0 ? (
        <div className="text-xs py-8 text-center" style={{ color: "var(--text-secondary)" }}>
          No upcoming dividend dates yet. Pay dates appear after holdings are added.
        </div>
      ) : (
        <ul className="space-y-3">
          {upcoming.slice(0, 8).map((e, i) => (
            <li
              key={`${e.ticker}-${i}`}
              data-testid={`calendar-event-${e.ticker}`}
              className="flex items-center justify-between border-b pb-3"
              style={{ borderColor: "var(--border)" }}
            >
              <div className="flex items-center gap-4">
                <div className="border px-2 py-1 text-[10px]" style={{ borderColor: "var(--border)", color: "var(--text-secondary)" }}>
                  {e.pay_date}
                </div>
                <div>
                  <p className="text-sm font-semibold">{e.ticker}</p>
                  <p className="text-[10px] truncate max-w-[180px]" style={{ color: "var(--text-secondary)" }}>
                    {e.name || ""}
                  </p>
                </div>
              </div>
              <div className="text-right">
                <p className="text-sm" style={{ color: "var(--gain)" }}>
                  +{fmtCurrency(e.estimated_payment)}
                </p>
                <p className="text-[10px]" style={{ color: "var(--text-secondary)" }}>
                  est. {e.shares} sh
                </p>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
